import React from "react";
import {
  FaGrinStars,
  FaBacon,
  FaBraille,
  FaWeight,
  FaLeaf,
  FaTooth,
  FaClipboardList,
  FaMale,
} from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa";
const ServicesSection = () => {
  const services = [
    {
      id: 1,
      image: "https://images.unsplash.com/photo-1599058917212-d750089bc07e",
      icon: FaWeight,
      title: "Slimming & Weight Management",
      description:
        "Inch loss, fat reduction, weight gain programs, body contouring, and diet-based solutions.",
      link: "/services/slimming/slimming-weight-management",
    },
    {
      id: 2,
      image: "https://images.unsplash.com/photo-1616394584738-fc6e612e71b9",
      icon: FaGrinStars,
      title: "Skin Care",
      description:
        "Acne treatment, pigmentation care, anti-aging, glow facials, and skin rejuvenation programs.",
      link: "/services/skin-care/beauty-facials",
    },
    {
      id: 3,
      image: "https://images.unsplash.com/photo-1608248543803-ba4f8c70ae0b",
      icon: FaBacon,
      title: "Hair Care",
      description:
        "Hair spa, hair fall control, dandruff treatment, scalp therapies, and nourishment solutions.",
      link: "/services/hair-care/hair-care-restoration",
    },
    {
      id: 4,
      image: "https://images.unsplash.com/photo-1596178060671-7a80dc8059ea",
      icon: FaBraille,
      title: "Body Care",
      description:
        "Body polishing, scrubs, wraps, relaxation therapies, and skin renewal treatments.",
      link: "/services/slimming/slimming-weight-management",
    },
    {
      id: 5,
      image: "https://images.unsplash.com/photo-1556228578-0d85b1a4d571",
      icon: FaLeaf,
      title: "Wellness & Detox",
      description:
        "Detox therapies, immunity boosting, stress relief, and holistic wellness care programs.",
      link: "/services/skin-care/beauty-facials",
    },
    {
      id: 6,
      image: "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5",
      icon: FaTooth,
      title: "Dental",
      description:
        "Dental cleaning, teeth whitening, smile correction, and oral hygiene treatments.",
      link: "/services/dental-care/dental-whitening",
    },
    {
      id: 7,
      image: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf",
      icon: FaClipboardList,
      title: "Programs & Plans",
      description:
        "Monthly, quarterly, and yearly customized beauty and wellness transformation plans.",
      link: "/services/slimming/hifu-body",
    },
    {
      id: 8,
      image: "https://images.unsplash.com/photo-1599351431202-1e0f0137899a",
      icon: FaMale,
      title: "Men’s Section",
      description:
        "Exclusive grooming, skin, hair, body, and wellness solutions designed specifically for men.",
      link: "/services/skin-care/beauty-facials",
    },
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h3 className="text-lg font-semibold text-gray-600 mb-4">
            Our Services
          </h3>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Best Sellers
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Renew your Skin, Hair, and Body Confidence with our expert
            consultations and advanced wellness technology.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {services.map((service) => (
            <div
              key={service.id}
              className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2"
            >
              {/* Service Image */}
              <div className="relative h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-300" />
              </div>

              {/* Service Content */}
              <div className="relative p-6 -mt-8 z-10">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-xl shadow-lg mb-4 group-hover:bg-primary group-hover:text-white transition-colors duration-300">
                  <service.icon className="text-2xl text-primary group-hover:text-white transition-colors duration-300" />
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-primary transition-colors duration-300">
                  {service.title}
                </h3>

                <p className="text-gray-600 leading-relaxed mb-4">
                  {service.description}
                </p>

                <a
                  href={service.link}
                  className="inline-flex items-center gap-2 text-primary font-semibold hover:text-primary-dark transition-colors duration-300 group/link"
                >
                  Learn More
                  <FaArrowRight className="text-sm group-hover/link:translate-x-1 transition-transform duration-300" />
                </a>
              </div>

              {/* Hover Effect Border */}
              <div className="absolute inset-0 rounded-2xl border-2 border-transparent group-hover:border-primary/20 transition-all duration-300" />
            </div>
          ))}
        </div>
      </div>

      {/* Custom Styles for Enhanced Effects */}
      <style jsx>{`
        .group:hover .group-hover\\:scale-110 {
          transform: scale(1.1);
        }
        .group:hover .group-hover\\:-translate-y-2 {
          transform: translateY(-0.5rem);
        }
      `}</style>
    </section>
  );
};

export default ServicesSection;
